import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SubmissionError } from 'redux-form';
import { debounce } from 'lodash';
import qs from 'qs';

import SignUp from '../../components/signup/form';
import { submitSignupForm, userExists } from '../../actions/index';
import { reportError } from '../../lib/error-reporter';

const COMPONENT_ID = 'DesktopSignupFormContainer';
class SignupContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { redirectTo: null };
    this.onLoginClick = this.onLoginClick.bind(this);
    this.onEmailChanged = debounce(this.onEmailChanged.bind(this), 200);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onLoginClick() {
    const query = qs.parse(window.location.search.substring(1));
    const loginLink = query.redirect ? `/login?redirect?${query.redirect}` : '/login';

    return this.setState({ redirectTo: loginLink });
  }

  onEmailChanged(email) {
    this.props.actions.userExists(email);
  }

  onSubmit(data) {
    return this.props.actions.submitSignupForm(data)
      .catch((error) => {
        reportError({
          error,
          component: COMPONENT_ID,
          params: {},
        });

        throw new SubmissionError({
          _error: error.response.data[0].message,
        });
      });
  }

  redirect() {
    window.location = this.state.redirectTo;
    return null;
  }

  render() {
    if (this.state.redirectTo) return this.redirect();
    return (
      <SignUp
        onLoginClick={this.onLoginClick}
        onSubmit={this.onSubmit}
        onEmailChanged={this.onEmailChanged}
        emailInUse={!!this.props.existence}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({
      submitSignupForm,
      userExists,
    }, dispatch),
  };
};

const mapStateToProps = ({ users }) => {
  return {
    currentUser: users.byId[users.current],
    existence: users.existence,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignupContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/signup/form.container.js